import type { RequestConfig } from '@customTypes/index';

import { api } from '@/shared/api/instance';

export type DeleteVideoItem = {
  videoId: string;
};

export type DeleteVideoItemParams = RequestConfig<DeleteVideoItem>;

export const deleteVideoItem = async ({
  params,
  config
}: DeleteVideoItemParams) =>
  api.delete(`/api/videos/${params.videoId}`, config);
